import type { FC } from 'react'

export const CircleEmptyGalleryIcon: FC<IconProps> = ({width, height}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.25 22C42.25 33.1838 33.1838 42.25 22 42.25C10.8162 42.25 1.75 33.1838 1.75 22C1.75 10.8162 10.8162 1.75 22 1.75C33.1838 1.75 42.25 10.8162 42.25 22Z"
      fill="#FFD5DC"
    />
    <path
      d="M23 10.75C23 10.1977 22.5523 9.75 22 9.75C21.4477 9.75 21 10.1977 21 10.75H23ZM21 26.5C21 27.0523 21.4477 27.5 22 27.5C22.5523 27.5 23 27.0523 23 26.5H21ZM23 33.2275C23 32.6752 22.5523 32.2275 22 32.2275C21.4477 32.2275 21 32.6752 21 33.2275H23ZM21 33.25C21 33.8023 21.4477 34.25 22 34.25C22.5523 34.25 23 33.8023 23 33.25H21ZM21 10.75V26.5H23V10.75H21ZM21 33.2275V33.25H23V33.2275H21ZM41.25 22C41.25 32.6315 32.6315 41.25 22 41.25V43.25C33.7361 43.25 43.25 33.7361 43.25 22H41.25ZM22 41.25C11.3685 41.25 2.75 32.6315 2.75 22H0.75C0.75 33.7361 10.2639 43.25 22 43.25V41.25ZM2.75 22C2.75 11.3685 11.3685 2.75 22 2.75V0.75C10.2639 0.75 0.75 10.2639 0.75 22H2.75ZM22 2.75C32.6315 2.75 41.25 11.3685 41.25 22H43.25C43.25 10.2639 33.7361 0.75 22 0.75V2.75Z"
      fill="#E5002B"
    />
  </svg>
)
